import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => (
  <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-[#071E45]" data-testid="hero-section">
    <div className="absolute inset-0">
      <img
        src="https://static.prod-images.emergentagent.com/jobs/d2ca7f8e-00c6-4430-9e4c-0d04d72e2047/images/2990a0f2e0b2494f25c0e8e7b92cff3f04dbcf71278244e451e49693eee8f9a4.jpeg"
        alt=""
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0B2A57]/95 via-[#0B2A57]/80 to-[#0B2A57]/40" />
    </div>
    <div className="absolute inset-0 opacity-[0.03]" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 500'%3E%3Cellipse cx='500' cy='250' rx='420' ry='200' fill='none' stroke='white' stroke-width='0.5'/%3E%3Cellipse cx='500' cy='250' rx='350' ry='170' fill='none' stroke='white' stroke-width='0.3'/%3E%3Cellipse cx='500' cy='250' rx='280' ry='140' fill='none' stroke='white' stroke-width='0.3'/%3E%3Cline x1='80' y1='250' x2='920' y2='250' stroke='white' stroke-width='0.3'/%3E%3Cline x1='500' y1='50' x2='500' y2='450' stroke='white' stroke-width='0.3'/%3E%3C/svg%3E")`,
      backgroundSize: 'cover', backgroundPosition: 'center',
    }} />
    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-24 w-full">
      <div className="max-w-3xl">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-sm tracking-[0.3em] uppercase text-white/50 mb-6 font-medium"
        >
          Taiga Sourcing
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight leading-[1.1] text-white mb-6"
          style={{ fontFamily: 'Cabinet Grotesk' }}
          data-testid="hero-title"
        >
          SOURCE FROM INDIA.<br />
          ONE PARTNER. MULTIPLE CATEGORIES.
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="text-base lg:text-lg text-white/70 leading-relaxed mb-10 max-w-2xl"
        >
          Bridging global buyers with suitable Indian manufacturers across apparel, tiles, bathware, home, lifestyle and more.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.7 }}
          className="flex flex-wrap gap-4"
        >
          <Link
            to="/request-sourcing"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white text-[#0B2A57] text-sm font-semibold tracking-wider uppercase transition-all hover:shadow-xl hover:-translate-y-0.5"
            data-testid="hero-cta-primary"
          >
            Request Sourcing
            <ArrowRight size={18} />
          </Link>
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-8 py-3.5 border border-white/30 text-white text-sm font-semibold tracking-wider uppercase transition-all hover:bg-white/10"
            data-testid="hero-cta-secondary"
          >
            Explore Categories
          </Link>
        </motion.div>
      </div>
    </div>
  </section>
);

export default HeroSection;
